module.exports = __webpack_public_path__ + "assets/img/btn-view-pedigree-chart-10e15665.png";